import type { TabFilter } from "@types";

export const GUEST_ALLOWED_CAMPAIGN_TABS = [
  "all",
  "spotlight",
  "active",
  "ended",
] as const satisfies readonly TabFilter[];

export const GUEST_RESTRICTED_CAMPAIGN_TABS = [
  "badges",
  "favourites",
] as const satisfies readonly TabFilter[];

export function isGuestAllowedCampaignTab(tab: TabFilter): boolean {
  return GUEST_ALLOWED_CAMPAIGN_TABS.some(
    (allowedTab) => allowedTab === tab,
  );
}

export function isGuestRestrictedCampaignTab(tab: TabFilter): boolean {
  return GUEST_RESTRICTED_CAMPAIGN_TABS.some(
    (restrictedTab) => restrictedTab === tab,
  );
}
